import { Link } from "react-router-dom";
import StatusBadge from "@/components/base/StatusBadge";

export interface RelatedCase {
  id: string;
  slug: string;
  title: string;
  category: string;
  status: string;
  summary: string;
  cover: string;
}

export default function RelatedCases({ items }: { items: RelatedCase[] }) {
  if (items.length === 0) {
    return null;
  }

  return (
    <section aria-labelledby="related-title" className="w-full border-t border-background-200 pt-10">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">RELATED</p>
          <h2 id="related-title" className="mt-3 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            相似结构的其他案例
          </h2>
        </div>
        <Link
          to="/cases"
          className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-primary-800"
        >
          返回案例库
          <i className="ri-arrow-right-line text-base" aria-hidden="true" />
        </Link>
      </div>

      <ul className="mt-6 grid grid-cols-1 gap-5 md:grid-cols-3">
        {items.map((item) => (
          <li
            key={item.id}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
          >
            <Link to={`/cases/${item.slug}`} className="block">
              <div className="h-36 w-full overflow-hidden bg-background-200">
                <img
                  src={item.cover}
                  alt={`${item.title}案例配图`}
                  title={`${item.title} - 相关案例`}
                  className="h-36 w-full object-top transition-transform duration-500 group-hover:scale-[1.03]"
                />
              </div>
            </Link>
            <div className="flex flex-1 flex-col p-4">
              <div className="flex flex-wrap items-center gap-2">
                <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] font-medium text-secondary-900">
                  {item.category}
                </span>
                <StatusBadge label={item.status} />
              </div>
              <h3 className="mt-3 font-heading text-sm font-semibold leading-snug text-foreground-950">
                <Link to={`/cases/${item.slug}`} className="transition-colors hover:text-primary-700">
                  {item.title}
                </Link>
              </h3>
              <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600">{item.summary}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}